/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_AccountInputs */

const en_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account data:`)
};

const de_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontodaten:`)
};

const fr_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données de compte :`)
};

const es_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de cuenta:`)
};

const it_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati dell'account:`)
};

const nl_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accountgegevens:`)
};

const pl_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane konta:`)
};

const fi_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilitiedot:`)
};

const da_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontodata:`)
};

const sv_privacy_data_processing_item_account = /** @type {(inputs: Privacy_Data_Processing_Item_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontodata:`)
};

/**
* | output |
* | --- |
* | "Account data:" |
*
* @param {Privacy_Data_Processing_Item_AccountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_account = /** @type {((inputs?: Privacy_Data_Processing_Item_AccountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_AccountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_account(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_account(inputs)
	if (locale === "es") return es_privacy_data_processing_item_account(inputs)
	if (locale === "it") return it_privacy_data_processing_item_account(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_account(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_account(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_account(inputs)
	if (locale === "da") return da_privacy_data_processing_item_account(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_account(inputs)
	return en_privacy_data_processing_item_account(inputs)
});